module.exports = __webpack_public_path__ + "ca2068be9df348d3b889a62fe4ec849f.png";